import { RescheduleCountResponse, RescheduleFilters, RescheduleItem } from "@myapp/contract";
import apiClient from "../../../shared/config/axios";
import { Paginated } from "../../../shared/types/IPaginationResponse";

export const rescheduleApi = {
  search: (params: RescheduleFilters & { page: number }) =>
    apiClient.get<Paginated<RescheduleItem>>("/reschedule/items", { params }),
  count: () =>
    apiClient.get<RescheduleCountResponse>("/reschedule/count"),
};
